import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required');
}

// The client talks to the v2 schema, so the type parameters have to say so
// too. Typing it as SupabaseClient<Database> defaults the schema slot to
// 'public' and every v2 query fails to typecheck.
const customSupabaseClient: SupabaseClient<Database, 'v2'> =
  createClient<Database, 'v2'>(supabaseUrl, supabaseAnonKey, {
    db: { schema: 'v2' },
  });

export default customSupabaseClient;

export {
  customSupabaseClient,
  customSupabaseClient as supabase,
};
